import React from 'react';
import PromotionCard from './PromotionCard';

const ALL_COLORS = ['yellow', 'red', 'blue', 'green'];

// Utility to chunk array into smaller arrays
const chunk = (arr, size) => 
  Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
    arr.slice(i * size, i * size + size)
  );

const PromotionGroup = ({ promotions }) => {
  const promotionRows = chunk(promotions, 3);

  return (
    <div className="promotion-group-content">
        {promotionRows.map((row, rowIndex) => {
            const rowColor = ALL_COLORS[rowIndex % ALL_COLORS.length];
            const availableCardColors = ALL_COLORS.filter(c => c !== rowColor);

            return (
                <div key={rowIndex} className={`promo-row colored-${rowColor}`}>
                    <div className="container">
                        <div className="card-grid-fixed">
                            {row.map((promo, cardIndex) => {
                                const cardColor = availableCardColors[cardIndex % availableCardColors.length];
                                return <PromotionCard key={promo.nombre} promotion={promo} cardColor={cardColor} />
                            })}
                        </div>
                    </div>
                </div>
            )
        })}
    </div>
  );
};

export default PromotionGroup;
